<template>
  <v-layout row>
    <v-flex xs12 sm10 offset-sm1 text-xs-center>
      <v-toolbar flat color="white" class="mb-3">
        <v-tooltip bottom>
          <v-btn icon light @click="$router.go(-1)" slot="activator">
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title
          >{{ $vuetify.t('$vuetify.calls.media') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <video ref="video" v-bind:class="{ flash: flashOn }" />
      <v-progress-linear
        :indeterminate="true"
        v-if="!isCameraReady"
      ></v-progress-linear>

      <v-card
        color="pink darken-2"
        :class="{
          'mr-3 mt-3 captureButton': $vuetify.breakpoint.mdAndUp,
          'mb-3 mt-3 captureButton': $vuetify.breakpoint.smAndDown
        }"
        @click.native="capture"
        v-if="media == 'photo' && isCameraReady"
      >
        <v-card-text class="white--text text-xs-center">
          <v-icon x-large color="white">photo_camera</v-icon>
          <div class="headline text-xs-center">
            {{ $vuetify.t('$vuetify.calls.takePicture') }}
          </div>
        </v-card-text>
      </v-card>

      <v-card
        color="deep-purple darken-2"
        :class="{
          'mr-3 mt-3 captureButton': $vuetify.breakpoint.mdAndUp,
          'mb-3 mt-3 captureButton': $vuetify.breakpoint.smAndDown
        }"
        @click.native="startRecord"
        v-if="media == 'video' && isCameraReady"
      >
        <v-card-text class="white--text text-xs-center">
          <v-icon x-large color="white">videocam</v-icon>
          <div class="headline text-xs-center">
            {{ $vuetify.t('$vuetify.calls.recordVideo') }}
          </div>
        </v-card-text>
      </v-card>

      <v-card
        color="red darken-2"
        :class="{
          'mr-3 mt-3 captureButton': $vuetify.breakpoint.mdAndUp,
          'mb-3 mt-3 captureButton': $vuetify.breakpoint.smAndDown
        }"
        @click.native="stopRecord"
        v-if="media == 'recording'"
      >
        <v-card-text class="white--text text-xs-center">
          <v-icon x-large color="white">stop</v-icon>
          <div class="headline text-xs-center">
            {{ $vuetify.t('$vuetify.calls.stopRecord') }}
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Howl } from 'howler'
export default {
  data() {
    return {
      mediaStream: null,
      isCameraReady: false,
      screenshotFormat: 'image/jpeg',
      media: this.$route.params.media,
      photoFormat: 'image/jpeg',
      recorder: null,
      frames: [],
      flashOn: false
    }
  },
  mounted() {
    this.readCalls()
    this.getStream()
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId'
    })
  },
  methods: {
    ...mapActions({
      readCalls: 'calls/readCalls',
      addMedia: 'calls/addMedia',
      addVideo: 'calls/addVideo'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    getStream() {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'environment' }, audio: false })
        .then(mediaStream => {
          this.mediaStream = mediaStream
          const v = this.$refs.video
          const self = this
          v.srcObject = mediaStream
          v.onloadedmetadata = function(e) {
            self.isCameraReady = true
            v.play()
          }
        })
        .catch(error => console.error('getUserMedia() error:', error))
    },
    capture() {
      this.cameraFlash()
      const media = {}
      media.src = this.getPhoto().toDataURL(this.photoFormat)
      media.model_id = this.activeCallId
      media.type = 'image'
      media.collection_name = 'media'
      this.addMedia({ id: this.activeCallId, media: media })
      this.setNotification(this.$vuetify.t('$vuetify.calls.photoTaken'))
      this.$router.push('/media')
    },

    getPhoto() {
      const video = this.$refs.video
      if (!this.ctx) {
        const canvas = document.createElement('canvas')
        canvas.height = video.clientHeight
        canvas.width = video.clientWidth
        this.canvas = canvas
        this.ctx = canvas.getContext('2d')
      }
      const { ctx, canvas } = this
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      return canvas
    },

    startRecord() {
      this.media = 'recording'

      const video = this.$refs.video.srcObject

      try {
        this.recorder = new MediaRecorder(video, { mimeType: 'video/webm' })
      } catch (e) {
        console.error('Exception while creating MediaRecorder: ' + e)
        return
      }

      this.recorder.ondataavailable = event => {
        this.frames.push(event.data)
      }
      this.recorder.start(100)
    },

    stopRecord() {
      this.media = 'video'

      const video = this.$refs.video.srcObject
      this.recorder.stop()
      video.getTracks().forEach(track => {
        track.stop()
      })
      const blob = new Blob(this.frames, { type: 'video/webm' })
      const media = {}
      const name = 'camera-recording-' + Date.now()
      media.src = URL.createObjectURL(blob)
      media.file = new File(this.frames, name, {
        type: 'video/webm',
        lastModified: Date.now()
      })
      media.type = 'video'
      media.name = name
      media.model_id = this.activeCallId
      this.addVideo({ id: this.activeCallId, media: media })
      this.setNotification(this.$vuetify.t('$vuetify.calls.videoRecorded'))
      this.getStream()
    },

    cameraFlash() {
      const sound = new Howl({
        src: ['./sounds/camera-shutter-click.mp3'],
        rate: 2
      })
      sound.play()
      this.flashOn = true
      const that = this
      setTimeout(function() {
        that.flashOn = false
      }, 100)
    }
  },
  destroyed() {
    const tracks = this.mediaStream.getTracks()
    tracks.map(track => track.stop())
  }
}
</script>

<style scoped>
.captureButton {
  cursor: pointer;
}
video {
  max-width: 100%;
  max-height: 46vh;
}
.flash {
  border: 10px solid rgba(255, 255, 255, 0.8);
}
</style>
